const euros = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

const eurosWithCents = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const eurosMicro = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
});

const percent = new Intl.NumberFormat('fr-FR', { style: 'percent', maximumFractionDigits: 1 });
const finePercent = new Intl.NumberFormat('fr-FR', { style: 'percent', maximumFractionDigits: 2 });

/** Montant au dix-millième d'euro, pour voir les intérêts grossir en direct. */
export function fmtEurMicro(value: number): string {
  return eurosMicro.format(value);
}

/** Montant arrondi à l'euro. */
export function fmtEur(value: number): string {
  const rounded = Math.round(value);
  return euros.format(rounded === 0 ? 0 : rounded);
}

/** Montant avec les centimes, pour les petites sommes comme les premiers intérêts. */
export function fmtEurPrecise(value: number): string {
  return Math.abs(value) < 100 ? eurosWithCents.format(value) : fmtEur(value);
}

/** Variation avec son signe : +120 € ou −45 €. */
export function fmtEurDelta(value: number): string {
  const formatted = fmtEur(Math.abs(value));
  if (Math.round(value) === 0) return formatted;
  return value > 0 ? `+${formatted}` : `−${formatted}`;
}

const points = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1 });

/** Points de bien-être avec leur signe : +3, −1,5. */
export function fmtPoints(value: number): string {
  const rounded = Math.round(value * 10) / 10;
  if (rounded === 0) return '0';
  return rounded > 0 ? `+${points.format(rounded)}` : `−${points.format(-rounded)}`;
}

export function fmtPct(value: number): string {
  return percent.format(value);
}

/** Un taux au centième de point : les taux de crédit et d'assurance (3,25 %, 0,12 %). */
export function fmtRate(value: number): string {
  return finePercent.format(value);
}

export function fmtDate(date: Date): string {
  return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
}
